"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _KPIBox = require("./KPIBox");
Object.keys(_KPIBox).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _KPIBox[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _KPIBox[key];
    }
  });
});